import { render, staticRenderFns } from "./CrossButton.vue?vue&type=template&id=aa292ba6&scoped=true&"
import script from "./CrossButton.vue?vue&type=script&lang=js&"
export * from "./CrossButton.vue?vue&type=script&lang=js&"
import style0 from "./CrossButton.vue?vue&type=style&index=0&id=aa292ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa292ba6",
  null
  
)

export default component.exports